import React from 'react';
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import LoadingScreen from "./LoadingScreen";

const AuthModRoute = () => {
	const { user, role, loading } = useAuth();
    const allowedRoles = ["ADMIN", "OWNER", "MODERATOR", 'DEV'];

	if (loading) {
		return <LoadingScreen />
	}
    if (!user) {
        return <Navigate to="/login" />;
    }
    if (!role) {
        return <Navigate to="/profile" />;
    }
	return allowedRoles.includes(role) ? <Outlet /> : <Navigate to="/profile" />;
};

export default AuthModRoute;
